import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { slugify } from 'Utils/Functions';

const HomeRedirectCity = ({ children }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { city: currentCityInURL } = useParams();

  const cityFromStoreRaw = useSelector((state) => state?.location?.cityName);
  const cityFromStore = slugify(cityFromStoreRaw);

  useEffect(() => {
    if (cityFromStore && currentCityInURL !== cityFromStore) {
      // Replace only the city part in the path
      const currentPath = location.pathname;
      const updatedPath = currentPath.replace(
        `/${currentCityInURL}`,
        `/${cityFromStore}`
      );
      navigate(updatedPath + location.search, { replace: true });
      console.log(updatedPath + location.search, { replace: true });
    }
  }, [cityFromStore]);

  if (!cityFromStore) return null;

  return <>{children}</>;
};

export default HomeRedirectCity;
